
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Link } from "react-router-dom";

export const Header = () => {
  const { toast } = useToast();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleGetStarted = () => {
    toast({
      title: "Welcome!",
      description: "Thank you for your interest. We'll be in touch shortly.",
    });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-primary">
              DubCity AI Solutions
            </Link>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/features" className="text-gray-600 hover:text-primary transition-colors">
              Features
            </Link>
            <Link to="/agents" className="text-gray-600 hover:text-primary transition-colors">
              Agents
            </Link>
            <Link to="/how-it-works" className="text-gray-600 hover:text-primary transition-colors">
              How It Works
            </Link>
            <Link to="/customer-support" className="text-gray-600 hover:text-primary transition-colors">
              Support
            </Link>
            <Button variant="default" onClick={() => window.location.href = 'https://forms.gle/qQLw9WTSNqFkdt8E9'}>
              Get Started
            </Button>
          </nav>
          
          <button 
            className="md:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b shadow-lg animate-fade-in">
            <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
              <Link 
                to="/features" 
                className="text-gray-600 hover:text-primary transition-colors p-2 hover:bg-gray-50 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Features
              </Link>
              <Link 
                to="/agents" 
                className="text-gray-600 hover:text-primary transition-colors p-2 hover:bg-gray-50 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Agents
              </Link>
              <Link 
                to="/how-it-works" 
                className="text-gray-600 hover:text-primary transition-colors p-2 hover:bg-gray-50 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                How It Works
              </Link>
              <Link 
                to="/customer-support" 
                className="text-gray-600 hover:text-primary transition-colors p-2 hover:bg-gray-50 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Support
              </Link>
              <Button 
                variant="default" 
                className="w-full"
                onClick={() => {
                  window.location.href = 'https://forms.gle/qQLw9WTSNqFkdt8E9';
                  setIsMobileMenuOpen(false);
                }}
              >
                Get Started
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
